import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../css/Page.module.css";
import data from "../Data";
import toast from "react-hot-toast";

function Bookings() {
  const [formData, setFormData] = useState({
    from: "",
    subject: "",
    information: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.from || !formData.subject || !formData.information) {
      toast.error("Please fill in all fields");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.from)) {
      toast.error("Please enter a valid email address");
      return;
    }

    // Create mailto link with form data
    const emailBody = `From: ${formData.from}\n\n${formData.information}`;
    const mailtoLink = `mailto:${data.Gmail}?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(emailBody)}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Show success message
    toast.success("Mail Sent!");
    
    // Reset form
    setFormData({
      from: "",
      subject: "",
      information: "",
    });
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <h1 className={styles.title}>Bookings</h1>
        <p className={styles.text}>
          Book Serenade Festival for your next event. We offer complete event production services including artist management, stage design, and technical support. Contact us to discuss your event requirements. Our team will be reaching out to you soon. Let's make this happen!
        </p>
        
        <form onSubmit={handleSubmit} className={styles.bookingForm}>
          <div className={styles.formGroup}>
            <label htmlFor="from" className={styles.formLabel}>
              From:
            </label>
            <input
              type="email"
              id="from"
              name="from"
              value={formData.from}
              onChange={handleChange}
              className={styles.formInput}
              placeholder="your.email@example.com"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="subject" className={styles.formLabel}>
              Subject:
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className={styles.formInput}
              placeholder="Event Booking Inquiry"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="information" className={styles.formLabel}>
              Information:
            </label>
            <textarea
              id="information"
              name="information"
              value={formData.information}
              onChange={handleChange}
              className={styles.formTextarea}
              placeholder="Tell us about your event requirements, date, venue, and any other details..."
              rows="6"
              required
            />
          </div>

          <button type="submit" className={styles.sendButton}>
            Send
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default Bookings;

